// extracted by mini-css-extract-plugin
module.exports = {"loading":"Image_loading__20YI0","image":"Image_image__1Ms87","placeholder":"Image_placeholder__305HB"};